// CORE
import React, { Component } from 'react'

// MODULES
import { 
	ModuleOne, 
	ModuleFive,
	ModuleTwentySeven } from '../../../components/Modules'

// STYLES
import classes from '../layout.css'

class IntravenousBisphosphonate extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>
				<ModuleOne 
					addToForm={addToForm}
					consentForm={consentForm}
				/>
				<p><strong>Please initial each paragraph after reading. If you have any questions, please ask your doctor BEFORE initialing.</strong></p>
				
				<ModuleTwentySeven 
					addToForm={addToForm}
					consentForm={consentForm}
				/>
				<h3>CONSENT</h3>
				I certify that I speak, read and write English and have read and fully understand this consent for surgery and have had my questions answered. All of the blanks were filled in before I initialed or signed the form.
				<ModuleFive 
					addToForm={addToForm}
					consentForm={consentForm}
				/>
			</form>
		)
	}
}

export default IntravenousBisphosphonate


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/2.js